/* tslint:disable:interface-name object-literal-sort-keys */
export interface CascadeLike {
    id: number | string;
    name?: string | null;
    cascadeType?: string | null;
    createdAt?: string | null;
}

export interface CascadeTab {
    id: string;
    label: string;
    cascadeType: string | null;
    cascade: CascadeLike;
}

const TYPE_ORDER = ["mailings", "notifications", "crmMessages"];

const TYPE_LABELS: Record<string, string> = {
    mailings: "Маркетинговые",
    notifications: "Сервисные",
    crmMessages: "YCLIENTS",
};

// Show only the standard cascades that the main channels page shows
// (Маркетинговые / Сервисные / YCLIENTS). Custom / non-standard cascades are not
// surfaced here — they aren't columns on the main page either.
export function buildCascadeTabs(cascades: CascadeLike[] | null | undefined): CascadeTab[] {
    const list = (Array.isArray(cascades) ? cascades : []).filter(
        (cascade) => cascade && cascade.id !== null && cascade.id !== undefined,
    );

    const tabs: CascadeTab[] = [];

    TYPE_ORDER.forEach((type) => {
        const cascade = list.find((item) => item.cascadeType === type);
        if (cascade) {
            tabs.push({
                id: String(cascade.id),
                label: TYPE_LABELS[type],
                cascadeType: type,
                cascade,
            });
        }
    });

    return tabs;
}

export function getDefaultCascadeTabId(tabs: CascadeTab[]): string | null {
    const mailings = tabs.find((tab) => tab.cascadeType === "mailings");
    return mailings?.id ?? tabs[0]?.id ?? null;
}
